<template>
  <div>
      <multiselect
              v-model="val"
              tag-placeholder="Нажмите Enter, чтобы вставить..."
              selectedLabel="Применен"
              placeholder="Введите новый тег..."
              deselectLabel="Нажмите, чтобы удалить"
              :showLabels="false"
              label="title"
              :loading="loading"
              track-by="title"
              :options="list"
              :taggable="true"
              :searchable="true"
              :multiple="true"
              @tag="add"
              @input="input"
              @search-change="search"
        ></multiselect>
        <br/>
        <br/>
  </div>
</template>
<script>

import {setTag} from '@/plugins/functions';

export default {
  name: "Tags",
  props: {
    value: {
      default: function(){
        return [];
      },
    },
    urlGet: {
      default: function(){
        return '';
      },
    },
    urlUpdate: {
      default: function(){
        return '';
      },
    },
    urlPush: {
      default: function(){
        return '';
      },
    },
    feature_id: {
      default: function(){
        return '';
      },
    },
  },
  data() {
    return {
        loading : false,
        val : [],
        list:[]
    };
  },
  created() {
      this.val = this.value;
      this.search();
  },
  methods: {
    setTag:setTag,
    add(val){
       this.setTag(this.urlPush,'POST', {title:val, feature_id:this.feature_id});
    },
    input(){
        this.setTag(this.urlUpdate,'PUT', {feature_id: this.feature_id, items:this.val});
    },
    search(query = ''){
      this.loading = true;
      this.$http
        .get(this.urlGet, {
          params: {
            q: query,
            feature_id:this.feature_id
          },
        })
        .then((response) => {
          this.list = response.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 400);
        });
    }
  },
  computed: {

  },
};
</script>

